import React, { useState, useEffect, useContext , Suspense} from "react";
import Phone from "@material-ui/icons/Phone";
import Email from "@material-ui/icons/Email";
import HomeIcon from "@material-ui/icons/Home";
import Skeleton from "@material-ui/lab/Skeleton";

import {
  WebContext,
  isEmptyObject,
  getPrivateApi,
  getDomainValue,
} from "../../../Utility";
import {
  API_DOMAIN_B2B2C,
  API_ENDPOINT_ACCOUNTS,
  API_SECTION_PAYMENT_INFO,
  POWERED_BY_TRAVCLAN_LINK,
  B2B2C_API_PUBLIC_VERSION,
} from "../../../Constants";
import componentsMap from "./components";
import { withBackground } from "../../../utils/withBackground";

const DUMMY_DATA = [
  {
    id: 6,
    image: "https://app.travclan.com/media/appcms/About_Us_Page.jpg",
    title: "NEW ADDITIONAL PAGE 1",
    text: "additonal page 1 test",
    link_name: "page-1",
    created_at: "2020-05-22T10:56:22.648720Z",
    updated_at: "2020-05-22T10:56:22.648759Z",
    website_data: 4,
    created_by: null,
    updated_by: null,
  },
  {
    id: 5,
    image: "https://app.travclan.com/media/appcms/About_Us_Page.jpg",
    title: "NEW ADDITIONAL PAGE 2",
    text: "additonal page 2 test",
    link_name: "page-2",
    created_at: "2020-05-22T10:56:19.467532Z",
    updated_at: "2020-05-22T10:56:19.467725Z",
    website_data: 4,
    created_by: null,
    updated_by: null,
  },
];

const WEBSITE_POWERED_BY_TRAVCLAN_DATA = {
  showWebsitePoweredByTravclan: true,
  showWebsitePoweredByTravclanUrl: POWERED_BY_TRAVCLAN_LINK,
};

export default () => {
  const [componentType, setComponentType] = useState(null);
  const [componentImg, setComponentImg] = useState(null);
  const [showMerchantLogo, setShowMerchantLogo] = useState(false);
  const [websitePoweredByTravclanData, setWebsitePoweredByTravclanData] =
    useState(WEBSITE_POWERED_BY_TRAVCLAN_DATA);
  const { memberProfile, footerTemplateType = "FOOTER_1" } =
    useContext(WebContext);
  let {
    phone_numbers = [],
    emails = [],
    display_address: addresses = [],
    is_show_powered_by_travclan = true,
  } = memberProfile;
  const domainName = getDomainValue(window.location.hostname);
  
  let footerObj = [
    {
      icon: <HomeIcon />,
      header: "Address",
      type: "address",
      content: addresses || "",
    },
    {
      icon: <Phone />,
      header: "Call us at",
      type: "phone",
      content: phone_numbers,
    },
    { icon: <Email />, header: "Write us at", type: "email", content: emails },
  ];
  useEffect(() => {
    const getRazorPayKey = async () => {
      const { data = {}, err2 = null } = await getPrivateApi(
        `${API_DOMAIN_B2B2C}${API_ENDPOINT_ACCOUNTS}${B2B2C_API_PUBLIC_VERSION}${API_SECTION_PAYMENT_INFO}?domain_name=${domainName}`
      );
      if (err2) {
        return;
      }
      let { results: keyData = [] } = data;
      if (keyData.length !== 0 && keyData[0].razorpay_key_id) {
        setShowMerchantLogo(true);
      }
    };
    if (domainName) getRazorPayKey();
  }, [domainName]);

  useEffect(() => {
    setWebsitePoweredByTravclanData({
      ...websitePoweredByTravclanData,
      showWebsitePoweredByTravclan: is_show_powered_by_travclan,
    });
  }, [is_show_powered_by_travclan]);

  useEffect(() => {
    if (isEmptyObject(memberProfile)) return;
    setComponentType(footerTemplateType?.card_type);
    setComponentImg(footerTemplateType?.background_image);
  }, [memberProfile,footerTemplateType]);

  if (!componentType) return null;
  const ComponentName = componentType ? componentsMap[componentType] : null;
  const MyComponentWithBackground = withBackground(
    ComponentName,
    footerTemplateType
  );
  return (
     <Suspense fallback={<Skeleton height={500} />}>
    <MyComponentWithBackground
      footerObj={footerObj}
      showMerchantLogo={showMerchantLogo}
      componentImg={componentImg}
      websitePoweredByTravclanData={websitePoweredByTravclanData}
    />
    </Suspense>
  );
};
